import { useEffect, useState } from 'react';

export default function useInfoPopupFlag(
    month: number,
    dayStart: number,
    hourStart: number,
    minuteStart: number,
    dayEnd: number,
    hourEnd: number,
    minuteEnd: number,
    timeZone: string,
): boolean {
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        const checkTime = () => {
            const now = new Date();

            // Получаем компоненты времени в указанной таймзоне
            const formatter = new Intl.DateTimeFormat('en-US', {
                timeZone,
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false,
            });

            const parts = formatter.formatToParts(now);
            const getPart = (type: string) => parseInt(parts.find((p) => p.type === type)?.value || '0', 10);

            const year = getPart('year');
            const currentMonth = getPart('month') - 1; // 0-11
            const currentDate = getPart('day');
            const currentHour = getPart('hour');
            const currentMinute = getPart('minute');

            const toTimeKey = (y: number, m: number, d: number, h: number, min: number) =>
                y * 100000000 + (m + 1) * 1000000 + d * 10000 + h * 100 + min;

            const nowKey = toTimeKey(year, currentMonth, currentDate, currentHour, currentMinute);
            const startKey = toTimeKey(year, month, dayStart, hourStart, minuteStart);
            const endKey = toTimeKey(year, month, dayEnd, hourEnd, minuteEnd);

            let active = false;

            if (startKey < endKey) {
                active = nowKey >= startKey && nowKey < endKey;
            } else if (startKey > endKey) {
                active = nowKey >= startKey || nowKey < endKey;
            } else {
                active = false;
            }

            setIsActive(active);
        };

        checkTime();
        const interval = setInterval(checkTime, 60_000);

        return () => clearInterval(interval);
    }, [month, dayStart, hourStart, minuteStart, dayEnd, hourEnd, minuteEnd, timeZone]);

    return isActive;
}
